<template>
  <div>
     <b-nav tabs align="center">
     <b-nav-item @click="activate('datenTab')" :active="id==='datenTab'" :key="6" v-if="hasRoles(['Admin','Disponent','Cutter'])" >
        <div class="icon-profile cutterkollegen-id-badge"></div>
        <span class="small-font">Daten</span>
     </b-nav-item>
     <b-nav-item @click="activate('adminTab')" :active="id==='adminTab'" :key="7" v-if="hasRoles(['Admin','Disponent'])">
        <div class="icon-profile cutterkollegen-user-cog"></div>
        <span class="small-font">Administrativ</span>
     </b-nav-item>
     <b-nav-item @click="activate('erfahrungTab')" :active="id==='erfahrungTab'" :key="8" v-if="hasRoles(['Admin','Disponent','Cutter'])" >
        <div class="icon-profile cutterkollegen-list"></div>
        <span class="small-font">Erfahrung</span>
     </b-nav-item>
     <b-nav-item @click="activate('filmTab')" :active="id==='filmTab'" :key="9" v-if="hasRoles(['Admin','Disponent','Mitglied'])" >
        <div class="icon-profile cutterkollegen-clapperboard"></div>
        <span class="small-font">Filmografie</span>
     </b-nav-item>
     <b-nav-item @click="activate('kundenTab')" :active="id==='kundenTab'" :key="10" v-if="hasRoles(['Admin','Disponent','Mitglied'])">
        <div class="icon-profile cutterkollegen-customer"></div>
        <span class="small-font">Kunden</span>
     </b-nav-item>
     <b-nav-item @click="activate('sendungenTab')" :active="id==='sendungenTab'" :key="11" v-if="hasRoles(['Admin','Disponent','Mitglied'])">
        <div class="icon-profile cutterkollegen-tv"></div>
        <span class="small-font">Sendungen</span>
     </b-nav-item>
     </b-nav>
  </div>
</template>
<script>
import utils from '@/utilities'

export default {
  name: 'ProfilMenu',
  props: ['user'],
  methods: {
    activate (id) {
      this.id = id
      this.$root.$emit('activate-profil-tab', id)
    },
    hasRoles (roles) {
      // make sure to take the roles from the token, as normal user doent have the roles in der user object
      return utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), roles)
    }
  },
  data () {
    return {
      id: 'datenTab'
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/partials/ProfilMenu.vue